import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, UserLogin } from 'ngx-sds-login';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ParametersDTO, ParametersDetailDTO } from 'src/app/infraestructure/interfaces/parameters/ParametersDTO';
import { Solicitud } from 'src/app/infraestructure/interfaces/referente/SolicitudDTO';
import { AgregarNovedadSolicitudI } from 'src/app/infraestructure/models/agregarNovedadSolicitud';
import { ParametricListsService } from 'src/app/infraestructure/services/parametric-lists/parametric-lists.service';
import { ReferentApiService } from 'src/app/infraestructure/services/referent/referent-api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-agregar-novedad',
  templateUrl: './agregar-novedad.component.html',
  styleUrls: ['./agregar-novedad.component.scss']
})
export class AgregarNovedadComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild('autofocus', { static: false }) autofocus: ElementRef | null = null;

  @Output() cancel = new EventEmitter<string>();
  @Output() reloadTable = new EventEmitter<number>();

  @Input() codeSolicitud: number = 0;
  @Input() solicitud = {} as Solicitud;

  $parametricList: ParametersDTO = new ParametersDTO();
  private $topSubcription = new Subject<void>();
  user$: Observable<UserLogin>;

  dataNovedad = {} as AgregarNovedadSolicitudI;

  dataTableSolicitud: any;
  rolId: number = 0;
  userId: number = 0;
  userRol: string = '';

  constructor(private _listSrv: ParametricListsService,
    private store: Store<AppState>,
    private refApiSrv: ReferentApiService) {
    this.user$ = this.store.select(state => state.user);
    this.user$.subscribe(user => {
      this.rolId = user.rolId;
      this.userId = user.id;
      user.roles.map(rol => {
        if (this.rolId == rol.id) this.userRol = rol.vcCodigoInterno; //this.formatCamelCase(rol.vcCodigoInterno.split('_')[1]);
      });
      console.log(this.userRol);
    });
  }

  ngOnInit(): void {
    this._listSrv.getDataLists('TIP_NOVEDADES')
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code == 200) {
          let ArrayList: ParametersDetailDTO[] = [];
          res.data.map((item: ParametersDetailDTO) => {
            const cadenaRoles = item.vcCodigoInterno;
            const valoresEntreCorchetes = cadenaRoles.match(/\[(.*?)\]/);
            if (valoresEntreCorchetes && valoresEntreCorchetes.length > 1) {
              const valoresSeparadosPorComas = valoresEntreCorchetes[1].split(',');
              if (valoresSeparadosPorComas.includes(this.userRol)) {
                ArrayList.push(item);
              }
            }
          });
          this.$parametricList.typeNewsList = ArrayList;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['solicitud'] && this.solicitud.id) {
      this.setDataTable();
    }
  }

  ngAfterViewInit() {
    if(this.autofocus) this.autofocus.nativeElement.focus();

    this.dataNovedad.solicitudId = this.codeSolicitud;
    this.dataNovedad.usuarioId = this.userId;
  }

  // formatCamelCase(palabra: string): string {
  //   const palabraFormateada = palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase();
  //   return palabraFormateada;
  // }

  setDataTable() {
    this.dataTableSolicitud = {
      id: this.solicitud.id,
      referenteSolicitud: this.solicitud.referente.vcNombreCompleto,
      fechaSolicitud: this.solicitud.dtFechaSolicitud,
      nombreDirectivo: this.solicitud.directorJefeDependencia.vcNombre,
      motivo: ''
    }
  }

  addNews() {
    this.refApiSrv.postSolicitudNovedades(this.dataNovedad)
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(res => {
      if (res.code === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `Novedad registrada`,
          text: `La novedad en la solicitud de servicio #${res.data.solicitudId} ha sido creada excitosamente`,
          showConfirmButton: true,
          confirmButtonColor: "#004884",
          confirmButtonText: "ACEPTAR",
        });

        this.onClose();
        this.reloadTable.emit(this.codeSolicitud);
      } else {
        const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
        Swal.fire({
          title: 'Errores',
          icon: 'error',
          html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
          showConfirmButton: true,
          confirmButtonColor: "#004884",
          confirmButtonText: "ACEPTAR",
        });
      }
    });
  }

  onSelect() {
    this.$parametricList.typeNewsList.filter((item : any) => {
      if (item.idParametroDetalle == this.dataNovedad.motivoNovedadId) return this.dataTableSolicitud.motivo = item.vcNombre;
    });
  }

  onClose() {
    this.cancel.emit('close');
  }
}
